/* ZilZal — offers engine (free-gift ladder, progress messages, Blox Fruits
   bundle with a server-timed 15-minute code, MM2 one-game rule).
   Config + translated strings come from snippets/zz-upsell.liquid (window.ZZ_UPSELL).
   All money is SAR cents; amounts are drawn as <span class="zz-amt"
   data-zz-sar-cents> so assets/zz-currency.js shows the visitor's currency.
   Checkout is the source of truth: every free gift is a native automatic
   discount and the bundle is a single-use code that expires server-side. This
   file only keeps the cart in step with those rules. */
(function () {
  'use strict';
  var C = window.ZZ_UPSELL;
  if (!C || window.__zzUpsell) return;
  window.__zzUpsell = true;

  var T = C.t || {};
  var ROOT = (C.root || '/').replace(/\/$/, '');
  var G = C.gifts;                       // key -> variant id
  var GV = {};                           // variant id -> key
  Object.keys(G).forEach(function (k) { GV[G[k]] = k; });

  var LADDERS = {
    mm2: [[50000, { harvester: 1, icepiercer: 1 }, 5], [30000, { harvester: 1 }, 4], [20000, { candy: 1 }, 3], [15000, { sugar: 1 }, 2], [7000, { electro: 1 }, 1]],
    bf: [[30000, { kitsune: 2, control: 1 }, 2], [20000, { kitsune: 1 }, 1]],
    other: [[15000, { mystery: 1 }, 1]]
  };

  /* ---------- helpers ---------- */
  function amt(c) {
    c = Math.max(0, Math.round(c));
    var p = (c / 100).toFixed(2).split('.');
    return '<span class="zz-amt" data-zz-sar-cents="' + c + '">' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + p[1] + ' SR</span>';
  }
  function esc(s) { return ('' + s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fill(s, map) { return String(s || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
  function ls(k, v) { try { if (arguments.length > 1) { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, JSON.stringify(v)); } else return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function ss(k, v) { try { if (arguments.length > 1) sessionStorage.setItem(k, JSON.stringify(v)); else return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function isGift(it) { return it.product_type === 'Gift' || GV[it.variant_id] != null; }
  var PREV_FETCH = window.fetch;
  function post(url, body, internal) {
    var h = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    if (internal) h['X-ZZ-Internal'] = '1';
    return window.fetch(ROOT + url, { method: 'POST', credentials: 'same-origin', headers: h, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  function getCart() { return PREV_FETCH(ROOT + '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  /* ---------- product groups (mirrors the collections the checkout discounts use) ---------- */
  var GKEY = 'zz_groups_v3:' + ROOT, TTL = 6 * 3600 * 1000, groups = null, groupsP = null;
  function fetchAll(handle) {
    var out = [];
    function page(n) {
      return PREV_FETCH(ROOT + '/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { var ps = d.products || []; out = out.concat(ps); return ps.length === 250 && n < 4 ? page(n + 1) : out; });
    }
    return page(1).catch(function () { return out; });
  }
  var FRUITS = ['t-rex', 'lightning', 'blizzard', 'kitsune', 'leopard', 'mammoth', 'phoenix', 'creation', 'diamond', 'buddha', 'portal', 'spider', 'spirit', 'shadow', 'gravity', 'control', 'dragon', 'magnet', 'rumble', 'quake', 'venom', 'sound', 'eagle', 'dough', 'magma', 'flame', 'light', 'yeti', 'sand', 'pain', 'dark', 'ice', 'gas'];
  var AR = { 'تنين': 'dragon', 'دراغون': 'dragon', 'ماقنيت': 'magnet', 'ماغنت': 'magnet', 'كتسوني': 'kitsune', 'كيتسوني': 'kitsune', 'بورتال': 'portal', 'يتي': 'yeti', 'كونترول': 'control', 'كوتنرول': 'control', 'ليوبارد': 'leopard', 'ماموث': 'mammoth', 'موتشي': 'dough', 'غاز': 'gas', 'تيريكس': 't-rex' };
  function fruitKey(p) {
    var s = (p.handle + ' ' + p.title).toLowerCase();
    for (var i = 0; i < FRUITS.length; i++) if (s.indexOf(FRUITS[i]) !== -1) return FRUITS[i];
    for (var a in AR) if (s.indexOf(a) !== -1) return AR[a];
    return '';
  }
  function kindOf(tags) {
    if (tags.indexOf('zz_storage') !== -1) return 'storage';
    if (tags.indexOf('group_en_perm') !== -1) return 'perm';
    if (tags.indexOf('group_en_fruits') !== -1) return 'fruit';
    if (tags.indexOf('group_en_skins') !== -1) return 'skin';
    return 'x';
  }
  function loadGroups() {
    if (groups) return Promise.resolve(groups);
    if (groupsP) return groupsP;
    var cached = ls(GKEY);
    if (cached && Date.now() - cached.t < TTL) { groups = cached.g; return Promise.resolve(groups); }
    var lists = [['mm2', C.mm2], ['bf', C.bf]].concat((C.other || []).map(function (h) { return ['other', h]; }));
    groupsP = Promise.all(lists.map(function (l) { return fetchAll(l[1]).then(function (ps) { return [l[0], l[1], ps]; }); }))
      .then(function (res) {
        var g = { p: {}, v: {}, bf: [] };
        res.forEach(function (r) {
          r[2].forEach(function (p) {
            if (p.product_type === 'Gift') return;
            var tags = p.tags || [];
            var rec = { g: r[0], game: r[0] === 'other' ? r[1] : r[0] };
            /* shelf (group_en_ tag) — the cart's cashback line gives some shelves their own rate */
            for (var ti = 0; ti < tags.length; ti++) { if (String(tags[ti]).indexOf('group_en_') === 0) { rec.s = String(tags[ti]).slice(9).trim().toLowerCase(); break; } }
            if (r[0] === 'bf') rec.k = kindOf(tags);
            if (!g.p[p.id] || r[0] === 'mm2') g.p[p.id] = rec;
            (p.variants || []).forEach(function (v) { g.v[v.id] = p.id; });
            if (r[0] === 'bf' && rec.k !== 'x') {
              var v0 = (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0] || {};
              g.bf.push({ id: p.id, v: v0.id, t: p.title, h: p.handle, c: Math.round(parseFloat(v0.price || 0) * 100), a: !!v0.available, k: rec.k, f: fruitKey(p), img: (p.images && p.images[0] && p.images[0].src) || '' });
            }
          });
        });
        groups = g; groupsP = null; ls(GKEY, { t: Date.now(), g: g });
        return g;
      })
      .catch(function () { groupsP = null; return { p: {}, v: {}, bf: [] }; });
    return groupsP;
  }
  function cls(it) { return groups && groups.p[it.product_id]; }

  /* ---------- gift ladder ---------- */
  function sums(cart) {
    var s = { mm2: 0, bf: 0, other: 0, games: {} };
    (cart.items || []).forEach(function (it) {
      if (isGift(it)) return;
      var c = cls(it); if (!c) return;
      if (c.g === 'mm2') s.mm2 += it.final_line_price;
      else if (c.g === 'bf') { if (c.k === 'perm' || c.k === 'fruit' || c.k === 'skin') s.bf += it.final_line_price; }
      else if (c.g === 'other') { s.other += it.final_line_price; s.games[c.game] = 1; }
    });
    return s;
  }
  function tierFor(ladder, sum) {
    for (var i = 0; i < ladder.length; i++) {
      if (sum < ladder[i][0]) continue;
      var ok = Object.keys(ladder[i][1]).every(function (k) { return C.stock[k] !== false; });
      if (ok) return ladder[i];
    }
    return null;
  }
  function nextFor(ladder, sum) {
    var n = null;
    for (var i = ladder.length - 1; i >= 0; i--) {
      if (sum >= ladder[i][0]) continue;
      var ok = Object.keys(ladder[i][1]).every(function (k) { return C.stock[k] !== false; });
      if (ok) { n = ladder[i]; break; }
    }
    return n;
  }

  var busy = false, lastSig = '', lastAt = 0;
  function reconcile(cart) {
    if (busy || !groups) return;
    var s = sums(cart);
    var off = ss('zz_gift_off') || {};
    var want = {};
    Object.keys(G).forEach(function (k) { want[G[k]] = 0; });
    ['mm2', 'bf', 'other'].forEach(function (key) {
      var t = tierFor(LADDERS[key], s[key]);
      if (!t) return;
      Object.keys(t[1]).forEach(function (gk) { if (!off[G[gk]]) want[G[gk]] += t[1][gk]; });
    });
    var have = {};
    (cart.items || []).forEach(function (it) { if (GV[it.variant_id] != null) have[it.variant_id] = (have[it.variant_id] || 0) + it.quantity; });
    var updates = {}, n = 0;
    Object.keys(want).forEach(function (vid) { if ((have[vid] || 0) !== want[vid]) { updates[vid] = want[vid]; n++; } });

    var attrs = null;
    var names = Object.keys(s.games).map(function (h) { return (C.gameNames || {})[h] || h; }).join('، ');
    var note = want[G.mystery] > 0 ? ('اختر عنصراً عشوائياً رخيصاً من: ' + names) : '';
    var cur = (cart.attributes || {})['Mystery Gift 🎁'] || '';
    if (cur !== note) attrs = { 'Mystery Gift 🎁': note };

    if (!n && !attrs) return;
    var sig = JSON.stringify([updates, attrs, cart.item_count]);
    if (sig === lastSig && Date.now() - lastAt < 5000) return;   // no loops
    lastSig = sig; lastAt = Date.now(); busy = true;
    var body = {};
    if (n) body.updates = updates;
    if (attrs) body.attributes = attrs;
    post('/cart/update.js', body, true).then(function () { busy = false; }).catch(function () { busy = false; });
  }

  /* ---------- drawer UI: progress + bundle card ---------- */
  function box() { return document.querySelector('[data-zzcart-offers]'); }
  function progressHtml(cart) {
    var s = sums(cart), out = '';
    var hasMM2 = s.mm2 > 0, rows = [];
    if (hasMM2) rows.push(['mm2', s.mm2]);
    else {
      if (s.bf > 0) rows.push(['bf', s.bf]);
      if (s.other > 0) rows.push(['other', s.other]);
    }
    rows.forEach(function (r) {
      var lad = LADDERS[r[0]], nx = nextFor(lad, r[1]), cur = tierFor(lad, r[1]);
      /* thin hint, always shown while a next gift exists (owner's choice). Reached gifts already
         show as «مجاناً» lines, so nothing extra is shown once the top tier is reached. */
      if (!nx) return;
      var left = nx[0] - r[1];
      var key = r[0] === 'other' ? 'next_other' : ('next_' + r[0] + '_' + nx[2]);
      var msg = fill(T[key], { amount: amt(left) });
      var base = cur ? cur[0] : 0;
      var pct = Math.max(4, Math.min(100, Math.round(100 * (r[1] - base) / (nx[0] - base))));
      var th = Object.keys(nx[1]).map(function (k) { var u = (C.giftImg || {})[k]; return u ? '<img src="' + esc(u) + '" alt="" loading="lazy">' : ''; }).join('');
      out += '<div class="zzo-line">' + (th ? '<span class="zzo-thumbs">' + th + '</span>' : '') + '<div class="zzo-lt"><div class="zzo-msg">' + msg + '</div><div class="zzo-bar"><i style="inline-size:' + pct + '%"></i></div></div></div>';
    });
    return out;
  }

  /* bundle (Blox Fruits only, never with MM2) */
  var DID = ls('zz_did') || (function () { var d = 'd' + Math.random().toString(36).slice(2) + Date.now().toString(36); ls('zz_did', d); return d; })();
  var offerReq = null;
  function bundlePick(cart) {
    if (!C.api || !groups || !groups.bf.length) return null;
    var cool = ls('zz_bundle_cool');
    if (cool && cool > Date.now()) return null;
    var lines = (cart.items || []).filter(function (it) { return !isGift(it); });
    if (lines.some(function (it) { var c = cls(it); return c && c.g === 'mm2'; })) return null;
    var inCart = {}; lines.forEach(function (it) { inCart[it.product_id] = 1; });
    var bf = groups.bf.filter(function (b) { return b.a; });
    var mk = function (it) { return groups.bf.filter(function (b) { return b.id === it.product_id; })[0]; };
    var perm = lines.map(mk).filter(function (b) { return b && b.k === 'perm'; })[0];
    var other = lines.map(mk).filter(function (b) { return b && (b.k === 'skin' || b.k === 'fruit'); })[0];
    var storage = bf.filter(function (b) { return b.k === 'storage' && !inCart[b.id]; })[0];
    var pick = [], trig = null;
    if (perm) {
      trig = perm;
      var m = bf.filter(function (b) { return (b.k === 'skin' || b.k === 'fruit') && b.f && b.f === perm.f && !inCart[b.id]; }).sort(function (a, b) { return b.c - a.c; })[0]
        || bf.filter(function (b) { return (b.k === 'skin' || b.k === 'fruit') && b.c >= 10000 && !inCart[b.id]; }).sort(function (a, b) { return b.c - a.c; })[0];
      if (m) pick.push(m);
    } else if (other) {
      trig = other;
      var p = bf.filter(function (b) { return b.k === 'perm' && b.f && b.f === other.f && !inCart[b.id]; })[0];
      if (p) pick.push(p);
    }
    if (!trig) return null;
    if (storage) pick.push(storage);
    if (!pick.length) return null;
    return { trig: trig, items: pick };
  }
  function fmtLeft(ms) { var s = Math.max(0, Math.floor(ms / 1000)); return String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0'); }

  function bundleHtml(cart) {
    var st = ls('zz_bundle');
    if (st && st.exp <= Date.now()) { expire(cart, st); return ''; }
    var bp = bundlePick(cart);
    if (st && (!bp || st.trig !== bp.trig.id)) {       // trigger item left the cart: keep the timer, hide the card
      if (!bp) return '';
    }
    if (!st) {
      if (!bp) return '';
      if (!offerReq) {
        offerReq = PREV_FETCH(C.api.replace(/\/$/, '') + '/offer', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ device: DID, customer: C.customer || null, pct: C.pct, trigger: bp.trig.id, items: bp.items.map(function (b) { return { product: b.id, variant: b.v }; }) })
        }).then(function (r) { return r.json(); }).then(function (d) {
          if (d && d.code && d.expiresAt) ls('zz_bundle', { code: d.code, exp: Date.parse(d.expiresAt), trig: bp.trig.id, pct: d.pct || C.pct, items: bp.items.map(function (b) { return b.v; }), prods: bp.items.map(function (b) { return b.id; }) });
          else if (d && d.cooldownUntil) ls('zz_bundle_cool', Date.parse(d.cooldownUntil));
          offerReq = null; paint();
        }).catch(function () { offerReq = null; });
      }
      return '';
    }
    var pct = st.pct || C.pct;
    var inCart = {}; (cart.items || []).forEach(function (it) { inCart[it.variant_id] = 1; });
    var added = st.items.every(function (v) { return inCart[v]; });
    var itemsHtml = st.items.map(function (v) {
      var b = groups.bf.filter(function (x) { return String(x.v) === String(v); })[0]; if (!b) return '';
      return '<div class="zzo-bi"><img src="' + esc(b.img) + '" alt="" loading="lazy"><span class="zzo-bn">' + esc(b.t) + '</span><span class="zzo-bp"><s>' + amt(b.c) + '</s> ' + amt(b.c * (100 - pct) / 100) + '</span></div>';
    }).join('');
    return '<div class="zzo-card zzo-bundle">'
      + '<div class="zzo-msg"><b>' + fill(esc(added ? T.bundle_added : T.bundle_title), { pct: pct }) + '</b></div>'
      + (added ? '' : '<div class="zzo-bl">' + itemsHtml + '</div>')
      + '<div class="zzo-brow"><span class="zzo-timer">' + esc(T.bundle_ends) + ' <b data-zzo-left>' + fmtLeft(st.exp - Date.now()) + '</b></span>'
      + (added ? '' : '<button type="button" class="zzo-add" data-zzo-add>' + esc(T.bundle_add) + '</button>') + '</div>'
      + '<div class="zzo-bar"><i data-zzo-tbar style="inline-size:' + Math.round(100 * (st.exp - Date.now()) / 900000) + '%"></i></div></div>';
  }
  function applyCode(code, cart, add) {
    var codes = (cart.discount_codes || []).map(function (d) { return d.code; }).filter(function (c) { return c && c.toUpperCase() !== code.toUpperCase(); });
    if (add) codes.push(code);
    return post('/cart/update.js', { discount: codes.join(',') }, true);
  }
  function expire(cart, st) {
    ls('zz_bundle', null);
    ls('zz_bundle_cool', st.exp + 7 * 24 * 3600 * 1000);
    if ((cart.discount_codes || []).some(function (d) { return d.code.toUpperCase() === st.code.toUpperCase(); })) applyCode(st.code, cart, false);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-zzo-add]'); if (!b) return;
    var st = ls('zz_bundle'); if (!st || st.exp <= Date.now()) return;
    b.disabled = true;
    post('/cart/add.js', { items: st.items.map(function (v) { return { id: v, quantity: 1 }; }) }, true)
      .then(function () { return getCart(); })
      .then(function (cart) { return applyCode(st.code, cart, true); })
      .catch(function () { b.disabled = false; });
  });

  var lastCart = null;
  function paint() {
    var el = box(); if (!el || !lastCart) return;
    var html = (C.enabled ? progressHtml(lastCart) : '') + (C.enabled ? bundleHtml(lastCart) : '');
    if (el.__h !== html) { el.innerHTML = html; el.__h = html; }
  }
  setInterval(function () {
    var st = ls('zz_bundle'); if (!st) return;
    var left = st.exp - Date.now();
    if (left <= 0) { if (lastCart) { expire(lastCart, st); paint(); } return; }
    var t = document.querySelector('[data-zzo-left]'); if (t) t.textContent = fmtLeft(left);
    var bar = document.querySelector('[data-zzo-tbar]'); if (bar) bar.style.inlineSize = Math.max(0, Math.round(100 * left / 900000)) + '%';
  }, 1000);

  /* a gift the customer removes stays removed for this session */
  document.addEventListener('click', function (e) {
    var row = e.target.closest('.zzcart__item.is-gift');
    if (!row || !e.target.closest('[data-zzremove]')) return;
    var vid = (row.getAttribute('data-key') || '').split(':')[0];
    var off = ss('zz_gift_off') || {}; off[vid] = 1; ss('zz_gift_off', off);
  }, true);

  function onCart(cart) {
    if (!cart || !cart.items) return;
    lastCart = cart;
    if (!groups && !cart.item_count) { paint(); return; }   /* empty cart: nothing to reconcile, the groups are not needed yet */
    loadGroups().then(function () { if (C.enabled) reconcile(cart); paint(); });
  }
  document.addEventListener('zz:cart', function (e) { onCart(e.detail); });

  /* ---------- MM2 one-game rule ---------- */
  var og = document.getElementById('zz-og'), pending = null;
  function ogOpen() { if (og) { og.hidden = false; document.documentElement.style.overflow = 'hidden'; } }
  function ogClose() { if (og) { og.hidden = true; document.documentElement.style.overflow = ''; pending = null; var b = og.querySelector('[data-zz-og-confirm]'); if (b) b.disabled = false; } }
  if (og) {
    og.addEventListener('click', function (e) { if (e.target.closest('[data-zz-og-close]')) ogClose(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !og.hidden) ogClose(); });
    og.querySelector('[data-zz-og-confirm]').addEventListener('click', function () {
      if (!pending) return ogClose();
      var p = pending; this.disabled = true;
      post('/cart/clear.js', {}, true)
        .then(function () { return post('/cart/add.js', { items: p }, true); })
        .then(function () { ogClose(); if (window.zzCartRefresh) window.zzCartRefresh(); })
        .catch(function () { window.location.reload(); });
    });
  }
  function readItems(body) {
    try {
      if (!body) return null;
      var get = null;
      if (typeof FormData !== 'undefined' && body instanceof FormData) get = function (k) { return body.get(k); };
      else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) get = function (k) { return body.get(k); };
      else if (typeof body === 'string' && body.charAt(0) === '{') {
        var j = JSON.parse(body);
        var arr = j.items || [j];
        return arr.filter(function (x) { return x && x.id; }).map(function (x) { return { id: +x.id, quantity: +x.quantity || 1 }; });
      } else if (typeof body === 'string') { var sp = new URLSearchParams(body); get = function (k) { return sp.get(k); }; }
      if (get && get('id')) return [{ id: +get('id'), quantity: +get('quantity') || 1 }];
    } catch (e) {}
    return null;
  }
  function isMM2Variant(vid) { var pid = groups && groups.v[vid]; return !!(pid && groups.p[pid] && groups.p[pid].g === 'mm2'); }
  function conflict(items, cart) {
    var real = (cart.items || []).filter(function (it) { return !isGift(it); });
    if (!real.length) return false;
    var inMM2 = items.some(function (x) { return isMM2Variant(x.id); });
    var inGift = items.every(function (x) { return GV[x.id] != null; });
    if (inGift) return false;
    var cartMM2 = real.some(function (it) { var c = cls(it); return c && c.g === 'mm2'; });
    var cartOther = real.some(function (it) { var c = cls(it); return !(c && c.g === 'mm2'); });
    return inMM2 ? cartOther : cartMM2;
  }
  function header(init, k) {
    var h = init && init.headers; if (!h) return null;
    if (typeof h.get === 'function') return h.get(k);
    return h[k] || h[k.toLowerCase()] || null;
  }
  window.fetch = function (input, init) {
    var url = '';
    try { url = typeof input === 'string' ? input : (input && input.url) || String(input); } catch (e) {}
    if (!/\/cart\/add(\.js)?(\?|$)/.test(url) || header(init, 'X-ZZ-Internal')) return PREV_FETCH.apply(this, arguments);
    var items = readItems(init && init.body);
    var self = this, args = arguments;
    if (!items || !items.length) return PREV_FETCH.apply(self, args);
    return Promise.all([loadGroups(), getCart()]).then(function (r) {
      if (!conflict(items, r[1])) return PREV_FETCH.apply(self, args);
      pending = items; ogOpen();
      return new Response(JSON.stringify({ status: 422, message: T.og_title, description: T.og_body }), { status: 422, headers: { 'Content-Type': 'application/json' } });
    }).catch(function () { return PREV_FETCH.apply(self, args); });
  };

  /* first run. Speed (Oct 2026): the product groups (one products.json per game collection — about 12
     requests, ~120 KB) were fetched on every page view. Now they are fetched only when they can matter:
     the cart already holds something, an item is being added (the fetch guard above waits for them), or —
     on product, collection and search pages, where adding is one tap away — at the first touch or once the
     page has loaded and the phone is idle, whichever comes first. A visitor who only reads the home page or
     the games page costs nothing. The 6-hour localStorage cache above is unchanged. */
  getCart().then(function (cart) {
    if (cart && cart.item_count > 0) onCart(cart);
    else if (cart && cart.items) lastCart = cart;
  }).catch(function () {});
  var warmed = false;
  function warm() { if (warmed) return; warmed = true; loadGroups(); }
  var main = document.getElementById('MainContent');
  var tpl = (main && main.getAttribute('data-template')) || '';
  if (/^(product|collection|search)/.test(tpl)) {
    ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) { window.addEventListener(ev, warm, { once: true, passive: true }); });
    var idle = window.requestIdleCallback || function (f) { setTimeout(f, 1200); };
    var onLoad = function () { idle(warm, { timeout: 4000 }); };
    if (document.readyState === 'complete') onLoad(); else window.addEventListener('load', onLoad);
  }
})();
